import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  BY_COMPANY_SORT_PROPERTY_CHANGE,
  BY_COMPANY_TYPE_FILTER_CHANGE,
  TABS_INDICES,
  WHITELIST_ADD_ASYNC,
  WHITELIST_DELETE_SELECTED_ASYNC,
  WHITELIST_EDIT_ASYNC,
  WHITELIST_GET_ASYNC,
  WHITELIST_PAGE_CHANGE,
  WHITELIST_SEARCH_FILTER_CHANGE,
  WHITELIST_SELECT_ALL,
  WHITELIST_SELECT_TOGGLE,
  WHITELIST_TYPES,
  WHITELIST_UNSELECT_ALL,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    selectedIds: [],

    addFormLoader: false,
    addFormError: null,

    editFormLoader: false,
    editFormError: null,

    byCompanySortProperty: '',
    byCompanyTypeFilter: 'all',

    page: 1,
    search: '',
    tableLoader: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case BY_COMPANY_TYPE_FILTER_CHANGE:
        return {
          ...state,
          error: null,
          loader: true,
          byCompanyTypeFilter: action.payload.value,
        }
      case BY_COMPANY_SORT_PROPERTY_CHANGE:
        return {
          ...state,
          error: null,
          loader: true,
          byCompanySortProperty: action.payload.value,
        }
      case COMPANY_FILTER_CHANGE:
      case WHITELIST_GET_ASYNC.INITIATE:
        return {
          ...state,
          error: null,
          loader: true,
          selectedIds: [],
        }
      case WHITELIST_GET_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          error: null,
          loader: false,
          tableLoader: false,
        }
      case WHITELIST_GET_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false, tableLoader: false }
      case WHITELIST_GET_ASYNC.CANCEL:
        return { ...state, loader: false, tableLoader: false }

      case WHITELIST_SELECT_TOGGLE:
        return state.selectedIds.filter((id) => id === action.payload.id)[0]
          ? {
              ...state,
              selectedIds: state.selectedIds.filter((id) => id !== action.payload.id),
            }
          : {
              ...state,
              selectedIds: [...state.selectedIds, action.payload.id],
            }
      case WHITELIST_SELECT_ALL:
        return {
          ...state,
          selectedIds: state.data.whitelisted
            .filter((item) =>
              action.payload.tab === TABS_INDICES.LINKS_SECTION
                ? item.wtype === WHITELIST_TYPES.LINKS
                : item.wtype !== WHITELIST_TYPES.LINKS
            )
            .map((item) => item.id),
        }
      case WHITELIST_UNSELECT_ALL:
        return {
          ...state,
          selectedIds: [],
        }

      case WHITELIST_ADD_ASYNC.INITIATE:
        return { ...state, addFormLoader: true, addFormError: null }
      case WHITELIST_ADD_ASYNC.ERROR:
        return { ...state, addFormError: action.error, addFormLoader: false }
      case WHITELIST_ADD_ASYNC.SUCCESS:
        return { ...state, addFormLoader: false, addFormError: null }
      case WHITELIST_ADD_ASYNC.CANCEL:
        return { ...state, addFormLoader: false, addFormError: null }
      case WHITELIST_EDIT_ASYNC.INITIATE:
        return { ...state, editFormLoader: true, editFormError: null }
      case WHITELIST_EDIT_ASYNC.ERROR:
        return { ...state, editFormError: action.error, editFormLoader: false }
      case WHITELIST_EDIT_ASYNC.SUCCESS:
        return { ...state, editFormError: null, editFormLoader: false }
      case WHITELIST_EDIT_ASYNC.CANCEL:
        return { ...state, editFormLoader: false, editFormError: null }

      case WHITELIST_DELETE_SELECTED_ASYNC.INITIATE:
        return { ...state, loader: true }
      case WHITELIST_DELETE_SELECTED_ASYNC.SUCCESS: {
        const mapRemovedIds = action.payload.deletedIds.reduce(
          (prev, curr) => ({ ...prev, [curr]: true }),
          {}
        )

        return {
          ...state,
          loader: false,
          selectedIds: state.selectedIds.filter((id) => !mapRemovedIds[id]),
          data: {
            ...state.data,
            whitelisted: state.data.whitelisted.filter((item) => !mapRemovedIds[item.id]),
          },
        }
      }
      case WHITELIST_DELETE_SELECTED_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case WHITELIST_DELETE_SELECTED_ASYNC.CANCEL:
        return { ...state, loader: false }
      case WHITELIST_PAGE_CHANGE:
        return {
          ...state,
          tableLoader: true,
          page: action.payload.value,
        }
      case WHITELIST_SEARCH_FILTER_CHANGE:
        return {
          ...state,
          tableLoader: true,
          search: action.payload.value,
        }
      default:
        return state
    }
  }
}
